let config;

export async function loadRuntimeConfig() {
  // Each page startup reads the deployed file, never the build-time environment.
  config = undefined;
  try {
    const response = await fetch('/config.json', { cache: 'no-store', signal: AbortSignal.timeout(20000) });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const value = await response.json();
    if (!value || typeof value !== 'object' || Array.isArray(value)) throw new Error('Expected a JSON object.');
    if (typeof value.API_URL !== 'string') throw new Error('API_URL must be a string (empty for same-origin APIs).');
    const apiUrl = value.API_URL.trim().replace(/\/+$/, '');
    if (apiUrl) {
      const url = new URL(apiUrl);
      if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password || url.search || url.hash) {
        throw new Error('API_URL must be an HTTP(S) URL without credentials, query or fragment.');
      }
    }
    for (const key of ['AUTH_REDIRECT_PATH', 'GOOGLE_CLIENT_ID']) {
      if (value[key] !== undefined && typeof value[key] !== 'string') throw new Error(`${key} must be a string.`);
    }
    config = Object.freeze({
      API_URL: apiUrl,
      AUTH_REDIRECT_PATH: value.AUTH_REDIRECT_PATH ?? '/dashboard',
      GOOGLE_CLIENT_ID: value.GOOGLE_CLIENT_ID ?? '',
    });
    return config;
  } catch (error) {
    throw new Error(`Unable to load runtime configuration (/config.json): ${error.message}`);
  }
}

export function getRuntimeConfig() {
  if (!config) throw new Error('Runtime configuration has not been loaded.');
  return config;
}

export function getApiBaseUrl() {
  return `${getRuntimeConfig().API_URL.replace(/\/+$/, '')}/api`;
}
